import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getFinancingCardColumns = () => [
  {
    key: "type",
    label: "Bezeichnung",
    minWidth: 300,
    maxWidth: 300,
    justifyContent: "start",
  },
  {
    key: "quantity",
    label: "Betrag",
    minWidth: 80,
    maxWidth: 120,
    justifyContent: "end",
  },
];

export const getFinancingCardData = ({ calculation }) => {
  const acquisitionCosts = calculation?.baseCalculation?.acquisitionCosts || 0;
  const investObjectPriceWithFurnitureAndBroker =
    calculation?.baseCalculation?.investObjectPriceWithFurnitureAndBroker || 0;

  const yearlyVectorCombinedLoan = calculation.yearlyVectorCombinedLoan;

  let totalPenaltyQuantity = 0;

  yearlyVectorCombinedLoan
    .filter(
      (item) =>
        item.regularLoanPenaltyInterest > 0 ||
        item.specialLoanPenaltyInterest > 0
    )
    .forEach((item) => {
      totalPenaltyQuantity +=
        item.regularLoanPenaltyInterest + item.specialLoanPenaltyInterest;
    });

  const totalPrice =
    acquisitionCosts +
    investObjectPriceWithFurnitureAndBroker +
    totalPenaltyQuantity;

  const financingCardData = [
    {
      type: "Gesamtaufwand",
      quantity: convertValueToLocale(totalPrice),
    },
    {
      type: "Eigenkapital für Immobiliendarlehen",
      quantity: convertValueToLocale(acquisitionCosts),
    },
    ...(totalPenaltyQuantity > 0
      ? [
          {
            type: "Bereitstellungszinsen",
            quantity: convertValueToLocale(totalPenaltyQuantity),
          },
        ]
      : []),
    {
      type: "Finanzierungsbedarf (Auszahlungsbetrag)",
      quantity: convertValueToLocale(investObjectPriceWithFurnitureAndBroker),
    },
  ];
  return financingCardData;
};
